import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Formats a date string to a localized date-time string
 * @param dateString - ISO date string to format
 * @param language - Language code ('ua' for Ukrainian, 'en' for English, etc.)
 * @returns Formatted date string in the format: MM/DD/YYYY, HH:MM:SS
 */
export function formatDateTime(dateString: string, language: string = 'en'): string {
    const date = new Date(dateString);
    const locale = language === 'ua' ? 'uk-UA' : 'en-US';
    return date.toLocaleString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
}
